import styled from "styled-components";
import { zIndex } from "theme/variables";

export const StyledWrapper = styled.div`
  position: absolute;
  z-index: ${zIndex.notBottom};
`;
